import React, { useEffect } from 'react';
import Routes from 'routes';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import { Loader } from 'components';
import { connect } from 'react-redux';
import { checkUserAuth } from 'store/actions/Auth';
import { useMountEffect } from 'hooks/useMountEffect';
import { useSessionReplaced } from 'hooks/useSessionReplaced';
import { useSessionReplacedListener } from 'hooks/useSessionReplacedListener';
import Modal from './components/common/Modal';
import wsClient from './utils/web-socket-client';
import { useSnackbar } from './utils/snackbar/SnackbarContext';
import { registerSnackbar } from './utils/snackbar/SnackbarNotify';
import PlatformMaintenanceGuard from 'utils/route-guard/PlatformMaintenanceGuard';
import ReleaseCheck from 'components/ReleaseUpdate/ReleaseCheck';

const SnackbarInitializer = () => {
    const trigger = useSnackbar();
    React.useEffect(() => {
        registerSnackbar(trigger);
    }, [trigger]);

    return null;
};

const App = ({ checkUserAuth, appInitialized }) => {
    useMountEffect(checkUserAuth);

    useEffect(() => {
        wsClient.initFromLocalStorage();
    }, []);

    useSessionReplaced();
    useSessionReplacedListener();

    if (!appInitialized) {
        return <Loader />;
    }

    return (
        <>
            <Notistack>
                <SnackbarInitializer />
                <ReleaseCheck>
                    <PlatformMaintenanceGuard>
                        <Routes />
                    </PlatformMaintenanceGuard>
                </ReleaseCheck>
                <Modal />
                <Snackbar />
            </Notistack>
        </>
    );
};

const mapStateToProps = ({ init }) => {
    const { appInitialized } = init;
    return { appInitialized };
};

export default connect(mapStateToProps, { checkUserAuth })(App);
